import { axiosClient } from "./axiosClient";
import { WallAuthor, WallPost } from "./groupWallApi";

// ── Forum „Tematy" w grupie (kategorie → tematy → posty=Comment) ──

export type TopicSummary = {
  id: string;
  category_id: string;
  title: string;
  author: WallAuthor;
  posts_count: number;
  locked: boolean;
  created_at: string;
  last_activity: string;
  can_delete: boolean;
};

export type TopicCategory = {
  id: string;
  name: string;
  position: number;
  topics: TopicSummary[];
};

export type TopicsIndex = {
  can_manage: boolean;
  categories: TopicCategory[];
};

export type TopicDetail = TopicSummary & {
  can_manage: boolean;
  posts: WallPost[]; // posty w temacie = pełne GroupPost (ten sam komponent co na ścianie)
};

export const getTopics = async (groupId: string): Promise<TopicsIndex> =>
  (await axiosClient.get(`voter_groups/${groupId}/topics`)).data;

export const getTopic = async (groupId: string, topicId: string): Promise<TopicDetail> =>
  (await axiosClient.get(`voter_groups/${groupId}/topics/${topicId}`)).data;

export const createTopicCategory = async (groupId: string, name: string): Promise<TopicCategory> =>
  (await axiosClient.post(`voter_groups/${groupId}/topic_categories`, { name })).data;

export const deleteTopicCategory = async (groupId: string, categoryId: string): Promise<void> => {
  await axiosClient.delete(`voter_groups/${groupId}/topic_categories/${categoryId}`);
};

export const createTopic = async (groupId: string, categoryId: string, title: string, body?: string): Promise<TopicDetail> =>
  (await axiosClient.post(`voter_groups/${groupId}/topics`, { category_id: categoryId, title, body })).data;

export const lockTopic = async (groupId: string, topicId: string): Promise<TopicDetail> =>
  (await axiosClient.post(`voter_groups/${groupId}/topics/${topicId}/lock`)).data;

export const deleteTopic = async (groupId: string, topicId: string): Promise<void> => {
  await axiosClient.delete(`voter_groups/${groupId}/topics/${topicId}`);
};

export const createTopicPost = async (groupId: string, topicId: string, body: string): Promise<WallPost> =>
  (await axiosClient.post(`voter_groups/${groupId}/topics/${topicId}/posts`, { body })).data;
